<div class="graduation-box">
  <h6 class="column-header">Graduation Decision</h6>
  <div class="graduation-cards">
    <button
      type="button"
      class="cert-card"
      [class.selected]="diplomaChoice === 'yes'"
      (click)="onDiplomaChoiceSelect('yes')">
      <div class="cert-card-label">Yes, this student has earned a NC high school diploma or its equivalency.</div>
    </button>
    <button
      type="button"
      class="cert-card"
      [class.selected]="diplomaChoice === 'no'"
      (click)="onDiplomaChoiceSelect('no')">
      <div class="cert-card-label">No, this student has not earned a NC high school diploma or its equivalency.</div>
    </button>
  </div>

  <div class="cert-action-row">
    <button
      class="close-button secondary_materials_button small_button"
      disableRipple="true"
      type="button"
      mat-stroked-button
      (click)="onCancel()">
      Cancel
    </button>
    <button
      class="primary_materials_button small_button"
      disableRipple="true"
      type="button"
      mat-stroked-button
      [disabled]="isSubmitDisabled"
      (click)="onSubmit()">
      @if (submitting) {
        <mat-spinner diameter="16" style="display: inline-block; margin-right: 8px"></mat-spinner>
      }
      {{ submitting ? 'Saving...' : 'Submit' }}
    </button>
  </div>
</div>
